import service from '@/services/customizePlugin';

export default {
  saveConfig: ({ commit, state }, payload) => {
    const data = {
      ...state.globalConfig,
      ...payload,
    };

    return service
      .saveConfig(data)
      .then(({ data: { fonts, ...rest } }) => {
        return commit('setGlobalConfig', {
          ...state.globalConfig,
          ...fonts,
          ...rest,
        });
      })
      .then(() => {
        commit(
          'showToast',
          {
            text: 'Email.successSaved',
            color: 'toast_default',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            text: 'Email.error',
            color: 'toast_error',
          },
          {
            root: true,
          }
        );
      });
  },
  getConfig: ({ commit }) => {
    return service.getConfig().then(result => {
      const res = result.widgetGlobalConfig;
      const { fonts, ...config } = res;
      commit('setGlobalConfig', { ...fonts, ...config });
      const newColorConfig = {};

      newColorConfig.stars_color = res.starsColor;
      newColorConfig.stars_color_product_and_collections = res.starsColorProductAndCollections;
      newColorConfig.navbar_color = res.navbarColor;
      newColorConfig.buttons_color = res.buttonsColor;
      newColorConfig.text_color = res.textColor;
      newColorConfig.secondary_text_color = res.secondaryTextColor;
      newColorConfig.navbar_text_color = res.navbarTextColor;
      newColorConfig.background_color = res.backgroundColor;
      newColorConfig.verified_badge_color = res.verifiedBadgeColor;
      newColorConfig.pagination_color = res.paginationColor;
      newColorConfig.reviews_card_border_color = res.reviewsCardBorderColor;
      newColorConfig.floating_widget_button_background_color =
        res.floatingWidgetButtonBackgroundColor;
      newColorConfig.floating_widget_button_text_color = res.floatingWidgetButtonTextColor;

      newColorConfig.badge_stars_color = res.badgeStarsColor;
      newColorConfig.badge_border_color = res.badgeBorderColor;
      newColorConfig.badge_background_color = res.badgeBackgroundColor;
      newColorConfig.badge_text_color = res.badgeTextColor;
      newColorConfig.badge_secondary_text_color = res.badgeSecondaryTextColor;

      newColorConfig.carousel_stars_color = res.carouselStarsColor;
      newColorConfig.carousel_text_color = res.carouselTextColor;
      newColorConfig.carousel_secondary_text_color = res.carouselSecondaryTextColor;
      newColorConfig.carousel_background_color = res.carouselBackgroundColor;
      newColorConfig.carousel_verified_badge_color = res.carouselVerifiedBadgeColor;
      newColorConfig.carousel_border_color = res.carouselBorderColor;
      newColorConfig.carousel_controls_color = res.carouselControlsColor;
      newColorConfig.carousel_product_name_color = res.carouselProductNameColor;

      // newColorConfig.header_content_color = res.headerContentColor;
      newColorConfig.reviews_number_color = res.reviewsNumberColor;
      newColorConfig.review_source_label_color = res.reviewSourceLabelColor;
      newColorConfig.search_placeholder_color = res.searchPlaceholderColor;
      newColorConfig.filter_labels_color = res.filterLabelsColor;
      newColorConfig.write_review_button_color = res.writeReviewButtonColor;
      newColorConfig.write_review_button_text_color = res.writeReviewButtonTextColor;
      newColorConfig.filter_sort_by_button_color = res.filterSortByButtonColor;
      newColorConfig.pagination_arrows_button_color = res.paginationArrowsButtonColor;
      newColorConfig.search_icon_color = res.searchIconColor;

      const newFontsConfig = {};

      newFontsConfig.navbarReviewsTitle = res.fonts.navbarReviewsTitleFontSize;
      newFontsConfig.navbarbuttons = res.fonts.navbarButtonsFontSize;
      newFontsConfig.filters = res.fonts.filtersFontSize;
      newFontsConfig.summaryCardAvgScore = res.fonts.starSummaryOverallScoreFontSize;
      newFontsConfig.summaryCardNoReviews = res.fonts.starSummaryReviewsnumFontSize;
      newFontsConfig.summaryCardBars = res.fonts.starSummaryProgressBarsFontSize;
      newFontsConfig.reviewCardPrimary = res.fonts.reviewsCardMainFontSize;
      newFontsConfig.reviewCardSecondary = res.fonts.reviewsCardSecondaryFontSize;
      newFontsConfig.reviewQandAHeadText = res.fonts.formHeadingsFontSize;
      newFontsConfig.reviewQandAPostButton = res.fonts.formPostFontSize;
      newFontsConfig.reviewQandAInsideText = res.fonts.formInputFontSize;
      newFontsConfig.otherPaginator = res.fonts.paginatorFontSize;
      newFontsConfig.otherQAndATitle = res.fonts.qnaTitleFontSize;

      newFontsConfig.badgeAvgScore = res.fonts.badgeAverageScore;
      newFontsConfig.badgePrimaryText = res.fonts.badgePrimary;
      newFontsConfig.badgeSecondaryText = res.fonts.badgeSecondary;

      newFontsConfig.carouselPrimaryText = res.fonts.carouselPrimary;
      newFontsConfig.carouselSecondaryText = res.fonts.carouselSecondary;

      const newOtherConfig = {};

      newOtherConfig.widget_top_section_style = res.widgetTopSectionStyle;
      newOtherConfig.themeStyles = res.widgetThemeStyle;
      newOtherConfig.showQAndA = res.questionsAndAnswersActive;
      newOtherConfig.reviewsPerPage = res.numberReviewsPerPage;
      newOtherConfig.reviewColumns = res.numberReviewColumns;
      newOtherConfig.shop = res.shop;
      newOtherConfig.server_url = res.serverUrl;
      newOtherConfig.language = res.preferredLanguage;
      newOtherConfig.date_format = res.preferredDateFormat;
      newOtherConfig.default_sorting = res.defaultSorting;
      newOtherConfig.showStarsIfNoReviews = res.displayStarsIfNoReviews;
      newOtherConfig.centerStarsMobile = res.centerStarsMobile;
      newOtherConfig.centerStarsMobileBreakpoint = res.centerStarsMobileBreakpoint;
      newOtherConfig.show_star_bars = res.showStarBars;
      newOtherConfig.star_bars_width = res.starBarsWidth;
      newOtherConfig.star_bars_width_auto = res.starBarsWidthAuto;
      newOtherConfig.reviews_card_border_active = res.reviewsCardBorderActive;
      newOtherConfig.widget_show_dates = res.widgetShowDates;
      newOtherConfig.display_widget_if_no_reviews = res.displayWidgetIfNoReviews;
      newOtherConfig.display_review_source = res.displayReviewSource;
      newOtherConfig.show_country_and_foreign_reviews = res.showCountryAndForeignReviews;
      newOtherConfig.display_floating_widget = res.displayFloatingWidget;
      newOtherConfig.floating_widget_button_position = res.floatingWidgetButtonPosition;

      newOtherConfig.show_customer_images_section = res.showCustomerImagesSection;
      newOtherConfig.show_review_images = res.showReviewImages;
      newOtherConfig.review_image_max_height = res.reviewImageMaxHeight;
      newOtherConfig.show_large_review_image = res.showLargeReviewImage;
      newOtherConfig.stars_alignment_product_page = res.starsAlignmentProductPage;
      newOtherConfig.stars_alignment_product_page_mobile = res.starsAlignmentProductPageMobile;
      newOtherConfig.stars_alignment_collections = res.starsAlignmentCollections;
      newOtherConfig.stars_alignment_collections_mobile = res.starsAlignmentCollectionsMobile;
      newOtherConfig.enable_widget_review_search = res.enableWidgetReviewSearch;

      newOtherConfig.badgeShopReviewsLink = res.badgeShopReviewsLink;

      newOtherConfig.carousel_theme_style = res.carouselThemeStyle;
      newOtherConfig.carousel_border_active = res.carouselBorderActive;
      newOtherConfig.carousel_widget_show_dates = res.carouselWidgetShowDates;
      newOtherConfig.carousel_auto_scroll = res.carouselAutoScroll;
      newOtherConfig.carousel_show_product_name = res.carouselShowProductName;
      newOtherConfig.carousel_featured_reviews = res.carouselFeaturedReviews;
      newOtherConfig.hide_review_count_widget = res.hideReviewCountWidget;
      newOtherConfig.special_pagination = res.specialPagination;
      newOtherConfig.show_full_customer_names = res.showFullCustomerNames;

      newOtherConfig.display_verified_badge = res.displayVerifiedBadge;
      newOtherConfig.review_card_border_radius = res.reviewCardBorderRadius;

      commit('loadConfigSuccess', {
        newColorConfig,
        newFontsConfig,
        newOtherConfig,
      });
    });
  },
  setLocalConfig: ({ commit }, res) => {
    const newColorConfig = {};

    newColorConfig.stars_color = res.stars_color;
    newColorConfig.stars_color_product_and_collections = res.stars_color_product_and_collections;
    newColorConfig.navbar_color = res.navbar_color;
    newColorConfig.buttons_color = res.buttons_color;
    newColorConfig.text_color = res.text_color;
    newColorConfig.secondary_text_color = res.secondary_text_color;
    newColorConfig.navbar_text_color = res.navbar_text_color;
    newColorConfig.background_color = res.background_color;
    newColorConfig.verified_badge_color = res.verified_badge_color;
    newColorConfig.pagination_color = res.pagination_color;
    newColorConfig.reviews_card_border_color = res.reviews_card_border_color;
    newColorConfig.floating_widget_button_background_color =
      res.floating_widget_button_background_color;
    newColorConfig.floating_widget_button_text_color = res.floating_widget_button_text_color;

    newColorConfig.badge_stars_color = res.badge_stars_color;
    newColorConfig.badge_border_color = res.badge_border_color;
    newColorConfig.badge_background_color = res.badge_background_color;
    newColorConfig.badge_text_color = res.badge_text_color;
    newColorConfig.badge_secondary_text_color = res.badge_secondary_text_color;

    newColorConfig.carousel_stars_color = res.carousel_stars_color;
    newColorConfig.carousel_text_color = res.carousel_text_color;
    newColorConfig.carousel_secondary_text_color = res.carousel_secondary_text_color;
    newColorConfig.carousel_background_color = res.carousel_background_color;
    newColorConfig.carousel_verified_badge_color = res.carousel_verified_badge_color;
    newColorConfig.carousel_border_color = res.carousel_border_color;
    newColorConfig.carousel_controls_color = res.carousel_controls_color;
    newColorConfig.carousel_product_name_color = res.carousel_product_name_color;

    // newColorConfig.header_content_color = res.header_content_color;
    newColorConfig.reviews_number_color = res.reviews_number_color;
    newColorConfig.review_source_label_color = res.review_source_label_color;
    newColorConfig.search_placeholder_color = res.search_placeholder_color;
    newColorConfig.filter_labels_color = res.filter_labels_color;
    newColorConfig.write_review_button_color = res.write_review_button_color;
    newColorConfig.write_review_button_text_color = res.write_review_button_text_color;
    newColorConfig.filter_sort_by_button_color = res.filter_sort_by_button_color;
    newColorConfig.pagination_arrows_button_color = res.pagination_arrows_button_color;

    newColorConfig.search_icon_color = res.search_icon_color;

    const newFontsConfig = {};

    newFontsConfig.navbarReviewsTitle = res.fonts.navbar_reviews_title_font_size;
    newFontsConfig.navbarbuttons = res.fonts.navbar_buttons_font_size;
    newFontsConfig.filters = res.fonts.filters_font_size;
    newFontsConfig.summaryCardAvgScore = res.fonts.star_summary_overall_score_font_size;
    newFontsConfig.summaryCardNoReviews = res.fonts.star_summary_reviewsnum_font_size;
    newFontsConfig.summaryCardBars = res.fonts.star_summary_progress_bars_font_size;
    newFontsConfig.reviewCardPrimary = res.fonts.reviews_card_main_font_size;
    newFontsConfig.reviewCardSecondary = res.fonts.reviews_card_secondary_font_size;
    newFontsConfig.reviewQandAHeadText = res.fonts.form_headings_font_size;
    newFontsConfig.reviewQandAPostButton = res.fonts.form_post_font_size;
    newFontsConfig.reviewQandAInsideText = res.fonts.form_input_font_size;
    newFontsConfig.otherPaginator = res.fonts.paginator_font_size;
    newFontsConfig.otherQAndATitle = res.fonts.qna_title_font_size;

    newFontsConfig.badgeAvgScore = res.fonts.badge_average_score;
    newFontsConfig.badgePrimaryText = res.fonts.badge_primary;
    newFontsConfig.badgeSecondaryText = res.fonts.badge_secondary;

    newFontsConfig.carouselPrimaryText = res.fonts.carousel_primary;
    newFontsConfig.carouselSecondaryText = res.fonts.carousel_secondary;

    const newOtherConfig = {};

    newOtherConfig.widget_top_section_style = res.widget_top_section_style;
    newOtherConfig.themeStyles = res.widget_theme_style;
    newOtherConfig.star_bars_width = res.star_bars_width;
    newOtherConfig.star_bars_width_auto = res.star_bars_width_auto;
    newOtherConfig.reviews_card_border_active = res.reviews_card_border_active;
    newOtherConfig.showQAndA = res.questions_and_answers_active;
    newOtherConfig.reviewsPerPage = res.number_reviews_per_page;
    newOtherConfig.reviewColumns = res.number_review_columns;
    newOtherConfig.shop = res.shop;
    newOtherConfig.server_url = res.server_url;
    newOtherConfig.language = res.preferred_language;
    newOtherConfig.date_format = res.preferred_date_format;
    newOtherConfig.default_sorting = res.default_sorting;
    newOtherConfig.showStarsIfNoReviews = res.display_stars_if_no_reviews;
    newOtherConfig.centerStarsMobile = res.center_stars_mobile;
    newOtherConfig.centerStarsMobileBreakpoint = res.center_stars_mobile_breakpoint;
    newOtherConfig.widget_show_dates = res.widget_show_dates;
    newOtherConfig.badgeShopReviewsLink = res.badge_shop_reviews_link;
    newOtherConfig.display_widget_if_no_reviews = res.display_widget_if_no_reviews;
    newOtherConfig.display_review_source = res.display_review_source;
    newOtherConfig.show_country_and_foreign_reviews = res.show_country_and_foreign_reviews;
    newOtherConfig.display_floating_widget = res.display_floating_widget;
    newOtherConfig.floating_widget_button_position = res.floating_widget_button_position;

    newOtherConfig.show_customer_images_section = res.show_customer_images_section;
    newOtherConfig.show_review_images = res.show_review_images;
    newOtherConfig.review_image_max_height = res.review_image_max_height;
    newOtherConfig.show_large_review_image = res.show_large_review_image;
    newOtherConfig.show_star_bars = res.show_star_bars;
    newOtherConfig.stars_alignment_product_page = res.stars_alignment_product_page;
    newOtherConfig.stars_alignment_product_page_mobile = res.stars_alignment_product_page_mobile;
    newOtherConfig.stars_alignment_collections = res.stars_alignment_collections;
    newOtherConfig.stars_alignment_collections_mobile = res.stars_alignment_collections_mobile;

    newOtherConfig.carousel_theme_style = res.carousel_theme_style;
    newOtherConfig.carousel_border_active = res.carousel_border_active;
    newOtherConfig.carousel_widget_show_dates = res.carousel_widget_show_dates;
    newOtherConfig.carousel_auto_scroll = res.carousel_auto_scroll;
    newOtherConfig.carousel_show_product_name = res.carousel_show_product_name;
    newOtherConfig.carousel_featured_reviews = res.carousel_featured_reviews;
    newOtherConfig.enable_widget_review_search = res.enable_widget_review_search;

    newOtherConfig.display_verified_badge = res.display_verified_badge;
    newOtherConfig.review_card_border_radius = res.review_card_border_radius;
    newOtherConfig.new_widget_version = res.new_widget_version;
    newOtherConfig.shop_widgets_updated = res.shop_widgets_updated;

    newOtherConfig.hide_review_count_widget = res.hide_review_count_widget;
    newOtherConfig.special_pagination = res.special_pagination;
    newOtherConfig.show_full_customer_names = res.show_full_customer_names;

    commit('loadConfigSuccess', {
      newColorConfig,
      newFontsConfig,
      newOtherConfig,
    });
  },
  setNewFontsConfig: ({ commit }, value) => {
    commit('setNewFontsConfig', value);
  },
  setNewOtherConfig: ({ commit }, value) => {
    commit('setNewOtherConfig', value);
  },
  incrementReviewsPerPage: ({ commit }) => {
    commit('incrementReviewsPerPage');
    // dispatch('updateReviewsPerPage');
  },
  decrementReviewsPerPage: ({ commit }) => {
    commit('decrementReviewsPerPage');
    // dispatch('updateReviewsPerPage');
  },
  setReviewColumns: ({ commit }, value) => {
    commit('setReviewColumns', value);
  },
  setNewColorConfig: ({ commit }, { param, value }) => {
    let newVal = null;
    if (typeof value === 'object') {
      newVal = value.hex8;
    }
    commit('setNewColorConfig', {
      param,
      value: newVal || value,
    });
  },
  updateReviewsPerPage: ({ dispatch, commit, state }) => {
    return service
      .updateReviewsPerPage(state.newOtherConfig.reviewsPerPage)
      .then(res => {
        commit('getMetafieldsJsonsSuccess', res.data.data, { root: true });
      })
      .catch(() => {
        dispatch(
          'showToast',
          {
            type: 'error',
            message: 'CustomizePlugin.setConfigFailed',
          },
          {
            root: true,
          }
        );
      });
  },
  updateWidgets: ({ dispatch, commit }, newWidgetVersion) => {
    return service
      .updateWidgets(newWidgetVersion)
      .then(res => {
        commit('getMetafieldsJsonsSuccess', res.data.data, { root: true });
      })
      .catch(() => {
        dispatch(
          'showToast',
          {
            type: 'error',
            message: 'CustomizePlugin.setConfigFailed',
          },
          {
            root: true,
          }
        );
      });
  },
  editRatings: ({ dispatch }, value) => {
    return service.editRatings(value).catch(() => {
      dispatch(
        'showToast',
        {
          type: 'error',
          message: 'CustomizePlugin.setConfigFailed',
        },
        {
          root: true,
        }
      );
    });
  },
  setConfig: ({ dispatch, commit }, config) => {
    service
      .setConfig(config)
      .then(res => {
        commit('getMetafieldsJsonsSuccess', res.data.data.shopifyMetafieldsJsons, { root: true });
        dispatch(
          'showToast',
          {
            type: 'success',
            message: 'CustomizePlugin.setConfigSuccess',
          },
          {
            root: true,
          }
        );
        if (config.type === 'badge') {
          commit('updateAccountInfoBadgeConfig', config, {
            root: true,
          });
        }
      })
      .catch(() => {
        dispatch(
          'showToast',
          {
            type: 'error',
            message: 'CustomizePlugin.setConfigFailed',
          },
          {
            root: true,
          }
        );
      });
  },
  setSortingMethod: ({ dispatch, commit }, data) => {
    commit('setSortingMethod', data);
    dispatch('setDefaultSorting');
  },
  setDefaultSorting: ({ commit, state }) => {
    service
      .setDefaultSorting(state.newOtherConfig['default_sorting'])
      .then(res => {
        commit('getMetafieldsJsonsSuccess', res.data.data.shopifyMetafieldsJsons, { root: true });
        commit(
          'showToast',
          {
            text: 'CustomizePlugin.setConfigSuccess',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            type: 'toast_error',
            text: 'CustomizePlugin.setConfigFailed',
          },
          {
            root: true,
          }
        );
      });
  },
  setLocalPluginData: ({ commit }, res) => {
    const pluginData = {};

    pluginData.product = res.product;
    pluginData.product.review_ugc = res.product.review_ugc || [];
    pluginData.reviews = res.reviews;
    pluginData.questions = res.questions;
    pluginData.pageCount = res.review_page_count;
    pluginData.foreignReviews = res.foreign_reviews;
    pluginData.averageStars = res.product.average_stars;
    pluginData.totalReviews = res.product.review_number;

    commit('loadPluginDataSuccess', {
      pluginData,
    });
  },
  toggleWidgetDisplay: ({ commit }, params) => {
    return service
      .toggleWidget(params)
      .then(() => {
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'Email.successSaved',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'CustomizePlugin.setConfigFailed',
          },
          {
            root: true,
          }
        );
      });
  },
  getActiveWidgets: ({ commit }) => {
    return service.getActiveWidgets().then(res => {
      const activeWidgets = res.data;
      commit('setActiveWidgets', activeWidgets);
    });
  },
};
